<template>
  <v-list-item two-line class="px-0 mx-0">
    <v-list-item-avatar size="64">
      <v-avatar size="64" color="nightDark">
        <v-icon size="36">
          {{ icon }}
        </v-icon></v-avatar
      >
    </v-list-item-avatar>

    <v-list-item-content>
      <v-list-item-title class="text-h5"> {{ title }}</v-list-item-title>
      <v-list-item-subtitle class="text-caption primary--text pt-1"
        >{{ subtitle }}
      </v-list-item-subtitle>
    </v-list-item-content>

    <template v-if="cakeStore.cakeStep <4">

    
    <v-list-item-action-text v-if="cakeStore.cakeStep > 1 && step == 1" class="text-right">
      <div class="text-body-1 mb-1">
        {{ cakeStore.cakeTitle }}
      </div>
      <v-chip color="secondary" label>
        {{ cakeStore.cakePrice | currency }}
      </v-chip>
    </v-list-item-action-text>

    <v-list-item-action-text
      v-if="cakeStore.cakeStep > 2 && step == 2"
      class="d-flex flex-column align-end"
    >
      <v-chip color="primary" label>
        {{ cakeStore.deliveryDate | moment("DD MMMM, dddd YYYY") }}
      </v-chip>
    </v-list-item-action-text>
  </template>


  </v-list-item>
</template>

<script>
import { useCakeStore } from "@/stores/cake";

export default {
  props: {
    step: {
      type: Number,
      required: false,
      default: 0,
    },
    icon: {
      type: String,
      required: false,
      default: "",
    },
    title: {
      type: String,
      required: false,
      default: "Başlık",
    },
    subtitle: {
      type: String,
      required: false,
      default: "Alt Başlık",
    },
  },
  setup() {
    const cakeStore = useCakeStore();
    return {
      cakeStore,
    };
  },
};
</script>

<style></style>
